export default __webpack_public_path__ + "static/media/greenside.805bf200.png";